<template>
	<div :class="classes">
		<div class="text" :title="option.text">{{ option.text }}</div>
		<div class="chips">
			<FontAwesomeIcon
				v-if="isSelected"
				class="selected-icon"
				:icon="[ `fas`, `check`]"
			/>
			<div v-if="option.count">
				<TeamingChip class="option-count">
					<template #text>{{ option.count }}</template>
				</TeamingChip>
			</div>
			<div v-if="option.mark">
				<TeamingChip class="option-mark">
					<template #text>{{ option.mark }}</template>
				</TeamingChip>
			</div>
		</div>
	</div>
</template>

<script>
import TeamingChip from "./TeamingChip.vue";

/**
 * Row component for all Teaming drop-downs
 * @see TeamingDropDown
 * @see TeamingTypeAhead
 */
export default {
	name: "DropDownRow",
	components: {
		TeamingChip,
	},
	props: {
		option: {
			type: Object,
			required: true,
		},
		isSelected: {
			type: Boolean,
			required: true,
		},
	},
	computed: {
		classes() {
			return {
				"drop-down-row": true,
				"drop-down-row--selected": this.isSelected,
			};
		},
	},
};
</script>

<style lang="scss" scoped>
$dropDownRowColor--hover: $color2-600;
$dropDownRowBackgroundColor--hover: $color2-100;
$dropDownRowColor--selected: $color2-500;
$dropDownRowBackgroundColor--selected: $color2-100;

$optionCountColor: $color1-700;
$optionCountBackgroundColor: $color1-100;

$optionMarkColor: $white;
$optionMarkBackgroundColor: $color1-500;
$optionMarkColor--hover: $white;
$optionMarkBackgroundColor--hover: $color2-500;

// NOTE: padding/margins have to be applied at the row level to
// ensure that hover highlighting looks correct
.drop-down-row {
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	align-items: center;

	padding: 0.25rem 0.5rem; // 4px 0px
	border: 0.0625rem solid transparent;
	border-radius: 0.5rem;
}

.drop-down-row:hover {
	color: $dropDownRowColor--hover;
	background-color: $dropDownRowBackgroundColor--hover;

	.option-mark {
		color: $optionMarkColor--hover;
		background-color: $optionMarkBackgroundColor--hover;
	}
}

.drop-down-row--selected {
	color: $dropDownRowColor--selected;
	background-color: $dropDownRowBackgroundColor--selected;

	&:hover {
		color: $dropDownRowColor--selected;
		background-color: $dropDownRowBackgroundColor--selected;
	}
}

.drop-down-row .text {
	text-align: left;
	text-overflow: ellipsis;
	overflow: hidden;
	white-space: nowrap;
}

.drop-down-row .chips {
	display: flex;
	flex-direction: row;
	justify-content: flex-end;
	align-items: center;
	gap: 0.5rem;
}

.drop-down-row .option-count {
	color: $optionCountColor;
	background-color: $optionCountBackgroundColor;
	border-radius: 0.6rem;
}

.drop-down-row .option-mark {
	color: $optionMarkColor;
	background-color: $optionMarkBackgroundColor;
	border-radius: 0.6rem;
}
</style>
